export type HttpCodes = 200 | 400 | 404 | 405 | 408 | 500;
